import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { authorizations } from '../data/mockData';
import { Upload, X } from 'lucide-react';
import { toast } from 'sonner';

export default function Authorization() {
  const [showUploadModal, setShowUploadModal] = useState(false);

  const handleUpload = () => {
    toast.success('Authorization document uploaded successfully');
    setShowUploadModal(false);
  };

  const columns = [
    { key: 'company', label: 'Company' },
    { key: 'domain', label: 'Domain' },
    { key: 'signedDate', label: 'Signed Date' },
    { key: 'expiryDate', label: 'Expiry Date' },
    { 
      key: 'status', 
      label: 'Status',
      render: (row) => <StatusBadge status={row.status} />
    }
  ];

  return (
    <div className="page-container" data-testid="authorization-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Authorization Records</h1>
          <p className="page-subtitle">Manage client authorization documents</p>
        </div>
        <button 
          className="btn-primary"
          onClick={() => setShowUploadModal(true)}
          data-testid="upload-auth-button"
        >
          <Upload size={18} />
          <span>Upload Authorization</span>
        </button>
      </div>

      <DataTable 
        columns={columns} 
        data={authorizations}
        searchable={true}
        emptyMessage="No authorization records found"
      />

      {showUploadModal && (
        <div className="modal-overlay" data-testid="upload-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">Upload Authorization</h3>
              <button 
                className="modal-close"
                onClick={() => setShowUploadModal(false)}
                data-testid="close-modal-button"
              >
                <X size={20} />
              </button>
            </div>
            <div className="modal-body">
              <div className="upload-area" data-testid="upload-area">
                <Upload size={48} className="upload-icon" />
                <p className="upload-text">Click to upload or drag and drop</p>
                <p className="upload-subtext">PDF, DOC, DOCX (max 10MB)</p>
              </div>
              <div className="modal-actions">
                <button 
                  className="btn-secondary"
                  onClick={() => setShowUploadModal(false)}
                  data-testid="cancel-upload-button"
                >
                  Cancel
                </button>
                <button 
                  className="btn-primary"
                  onClick={handleUpload}
                  data-testid="confirm-upload-button"
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
